module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Lobby_cam03_D4.2cd84ecf.jpg";